import axios, { CancelTokenSource } from 'axios';
export default class DigServices {
  getSourceAdaptors(obj:any,tokenSource?: CancelTokenSource) {
    return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`dig/adaptors`,{
      cancelToken:tokenSource?.token,
      params:obj
    });
  }
  AddSourceAdaptor(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      process.env.REACT_APP_API_GLOBAL_URL+`dig/adaptors/add`,
      obj,
      { headers }
    );
  }

  EditSourceAdaptor(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      process.env.REACT_APP_API_GLOBAL_URL+`dig/adaptors/update`,
      obj,
      { headers }
    );
  }

  DeleteSourceAdaptor(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      process.env.REACT_APP_API_GLOBAL_URL+`dig/adaptors/delete`,
      obj,
      { headers }
    );
  }
}
